// Copyright Epic Games, Inc. All Rights Reserved.

import { ESystemID, makeErrorCode } from "./index";

export enum EUIErrorCodes {
  NotFound = "NF",
  UnexpectedError = "UE",
}

/**
 * @ErrorCode EOS-UI-NF
 * @Description Can not find a page with provided URL. Probably due to bad
 * configuration of the UI Helper when you launch it.
 */
export const UINotFoundErrorCode = makeErrorCode(
  ESystemID.UI,
  EUIErrorCodes.NotFound
);

/**
 * @ErrorCode EOS-UI-UE
 * @Description Unexpected error happened and we can't define the flow in which
 * the error has occurred.
 */
export const UIUnexpectedErrorErrorCode = makeErrorCode(
  ESystemID.UI,
  EUIErrorCodes.UnexpectedError
);
